import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { AccountGroupKey } from 'api/Trading-Accounts/Types/AccountGroupDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const accountGroupColumn: GridColumn[] = [
  {
    title: 'Name',
    field: AccountGroupKey.NAME,
    show: true,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsAccountGroups.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Account Group Type',
    field: AccountGroupKey.ACCOUNT_GROUP_TYPE,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Trading Platform Type',
    field: AccountGroupKey.PLATFORM_TYPE,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Trading Account Type',
    field: AccountGroupKey.TRADING_ACCOUNT_TYPE,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Currency',
    field: AccountGroupKey.CURRENCY,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Book Type',
    field: AccountGroupKey.BOOK_TYPE,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Classification Type',
    field: AccountGroupKey.CLASSIFICATION_TYPE,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Currency',
    field: AccountGroupKey.CURRENCY,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Entity',
    field: AccountGroupKey.TICKMILL_COMPANY,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.tickmillCompany.id}>
            {props.dataItem.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    show: true,
    width: 80,
    minResizableWidth: 80,
  },
]

export default accountGroupColumn
